module.exports = __webpack_public_path__ + "static/media/phone_map.77bab20e.svg";